import dayjs from "dayjs";

export function getExpirationDateMidnight() {
	return dayjs()
		.add(dayjs(dayjs().add(1, "day").format("YYYY-MM-DD")).diff(dayjs(), "minutes"), "minutes")
		.format();
}
